// Import necessary modules and components
import React from 'react';

import { Admin, Resource, ListGuesser } from 'react-admin';
import jsonServerProvider from 'ra-data-json-server';
import authProvider from '../providers/AuthProvider';
import { PromptList } from './components/PromptList';
import {CategoryList} from './components/CategoryList';
import EditPrompt from './components/EditPrompt';
import EditCategory from './components/EditCategory';

import PostIcon from '@mui/icons-material/Book';
import { PromptShow } from './components/PromptShow';
import CreatePrompt from './components/CreatePrompt';
import CreateCategory from './components/CreateCategory';
import { CategoryShow } from './components/CategoryShow';
import apiUrl from '../api-config';
// Configure the data provider with the JSON Server URL
const dataProvider = jsonServerProvider(apiUrl);
function AdminApp() {
    return (
            <Admin dataProvider={dataProvider} basename="/admin"
    authProvider={authProvider}
    // dashboard={"prompts"}
    requireAuth
    >
        <Resource name="prompts" 
        list={PromptList} 
        create={CreatePrompt}
        edit={EditPrompt} icon={PostIcon}
         show={PromptShow}
         />
        <Resource name="categories" 
        list={CategoryList}
        create={CreateCategory}  
        edit={EditCategory}
        show={CategoryShow}
        
        
        />
      </Admin>
    )
}

export default AdminApp
